
import { useStore } from 'vuex'
import { connectWallet } from '../libs/connectWallet'
import { chainId } from '../libs/config'
import { useNetwork } from './useNetwork'
import { toRaw } from 'vue'
import { ethers } from 'ethers'
export const useIsActivating = () => {
  const store = useStore()
  let provider = null
  const getProvider = async(init) => {
    try {
      provider = await connectWallet(init)
      let network = await provider.getNetwork()
      if (network.chainId == chainId) {
        store.commit('setNetwork', toRaw(network))
        store.commit('setProvider', toRaw(provider))
        getWallet()
      } else {
        const { switchChain } = useNetwork()
        switchChain(chainId)
      }
    } catch (error) {
      console.error(error) 
    }
  }

  const getNetwork = async() => {
    if (!provider) return
    let network = await provider.getNetwork()
    store.commit('setNetwork', toRaw(network))
  }

  const getWallet = async() => {
    if (!provider) return
    let accounts = await provider.listAccounts()
    if (accounts.length) {
      let address = accounts[0]
      store.commit('setAddress', address)
      try {
        provider.getBalance(address).then(res => {
          let balance = res
          let balanceInEth = ethers.utils.formatEther(balance)
          store.commit('setBalance', toRaw(balanceInEth))
        })
      } catch (error) {
        console.error(error)
      }
    }
  }

  return {
    getProvider,
    getWallet,
    getNetwork
  }
}
